import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction, QuoteItemBaqData } from '@frontend/api';

export type MergeQuoteItemsAsSupportingFilesQueryVars = {
  quoteId: number;
  parentId: number;
  childrenIds: number[];
};

export const getMergeQuoteItemsAsSupportingFilesKey = () =>
  ['quotes', 'quoteItems', 'mergeAsSupportingFiles'] as const;

export const useMergeQuoteItemsAsSupportingFiles: MutationFunction<
  QuoteItemBaqData,
  MergeQuoteItemsAsSupportingFilesQueryVars
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/merge_items_as_supporting_files`, {
        init: { method: 'POST', body },
      }),
    ...queryOptions,
    mutationKey: getMergeQuoteItemsAsSupportingFilesKey(),
  });
};
